import { Link } from '@tanstack/react-router'

export default function NotFound() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 text-center">
      <p className="mb-3 font-serif text-sm font-semibold uppercase tracking-wider text-primary">
        404
      </p>
      <h1 className="mb-3 font-serif text-3xl font-bold text-on-surface">
        Page not found
      </h1>
      <p className="mb-6 max-w-md text-on-surface-variant">
        The page you're looking for doesn't exist or has moved.
      </p>
      <Link
        to="/"
        className="rounded-full bg-primary px-6 py-2 text-sm font-semibold text-white transition-colors hover:bg-primary-container"
      >
        Back to home
      </Link>
    </div>
  )
}
